import React, { useState, useEffect } from "react"
import Select from "react-select"
import _ from "lodash"
import { connect } from "react-redux"
import { Controller, useForm } from 'react-hook-form';
import cleanDeep from 'clean-deep';
import { Actions as VIFTO_ACTIONS } from "./store/viftoActions.js";
import { CheckIcon, ChevronDownIcon, Cog8ToothIcon as CogIcon, MinusIcon, } from "@heroicons/react/20/solid"
import { NotificationManager } from 'react-notifications';

import viftoLogo from "./assets/vifto-logo.svg"

const ViftoSettings = ({
  disabled,
  viftoConnect,
  connected,
  tenants,
  updateViftoTenant,
  currentTenant,
  expenseOptions,
  companyDetails,
  taxNames,
  updateViftoDetails,
  expenseSettings,
  getViftoExpenseSettings,
  saving,
  hasSelectedTenant,
  disconnect
}) => {

  const { register, handleSubmit, control } = useForm();

  const [tenant, setTenant] = useState(false);
  const [updateTenant, setUpdateTenant] = useState(false);
  const [expand, setExpand] = useState(false);
  const [connecting, setConnecting] = useState(false);
  const [pageUpdated, setPageUpdated] = useState(false);

  const onSubmit = (data) => {
    viftoConnect(data.email, data.password);
  };

  const saveViftoData = (data) => {
    delete data.email;
    delete data.password;

    const dataToSave = {};

    Object.keys(data).map(field => {
      if (!dataToSave[field]) dataToSave[field] = { credit: { id: "", value: "" }, debit: { id: "", value: "" } };
      dataToSave[field].credit = { id: data[field]?.credit?.id, value: data[field]?.credit?.value };
      dataToSave[field].debit = { id: data[field]?.debit?.id, value: data[field]?.debit?.value };
    });

    const requiredFields = ["basic", "Maternity", "FSS", "SSC EE", "SSC ER"];
    const output = [];
    requiredFields.map(f => {
      ["credit", "debit"].map(type => {
        if (!dataToSave[f][type].id) output.push(`${f.charAt(0).toUpperCase()}${f.substring(1)} ${type}`);
      });
    });

    if (output.length) {
      NotificationManager.error(`${output.join(", ")} ${output.length != 1 ? "are" : "is"} required`, 'Vifto Integration');
      return;
    }

    updateViftoDetails(cleanDeep(dataToSave));
  };

  useEffect(() => {
    if (hasSelectedTenant) getViftoExpenseSettings()
  }, [hasSelectedTenant])

  useEffect(() => {
    setTenant(currentTenant);
  }, [currentTenant]);

  useEffect(() => {
    if (pageUpdated) setPageUpdated(false);
  }, [pageUpdated]);

  if (!connected && !tenants?.length) {
    return (
      <div className="col-xs-12 integration-row">
        <div className="col-xs-3">
          <div className="pull-left">
            <img src={viftoLogo} width="40px" />
            <span style={{ paddingLeft: 20, fontSize: 16 }}>Vifto</span>
          </div>
        </div>
        <div className="col-xs-9">
          {connecting ?
            <form onSubmit={handleSubmit(onSubmit)}>
              <button type="submit" className="btn btn-primary pull-right">
                Connect
              </button>
              <div className="col-xs-3 pull-right">
                <div className="form-material">
                  <input
                    className="form-control"
                    type="text"
                    autoComplete="off"
                    id="email"
                    name="email"
                    disabled={disabled}
                    ref={register}
                  />
                  <label htmlFor="password">Email</label>
                  <div className="clearfix" />
                </div>
                <div className="clearfix" />
                <div className="form-material">
                  <input
                    className="form-control"
                    type="password"
                    autoComplete="off"
                    id="password"
                    name="password"
                    disabled={disabled}
                    ref={register}
                  />
                  <label htmlFor="password">Password</label>
                  <div className="clearfix" />
                </div>
                <div className="clearfix" />
              </div>
            </form>
            :
            <a className="btn btn-primary pull-right" onClick={() => setConnecting(true)}>
              Connect
            </a>
          }
        </div>
      </div>
    )
  }

  return (
    <div className={`${expand ? "tr-gray" : ""} col-xs-12 integration-row`}>
      <div className="col-xs-3">
        <div className="pull-left">
          <img src={viftoLogo} width="40px" />
          <span style={{ paddingLeft: 20, fontSize: 16 }}>Vifto</span>
        </div>
      </div>
      <div className="col-xs-9">
        <div className="btn btn-default pull-right" style={{ paddingRight: 6 }} onClick={() => setExpand(!expand)}>
          <CogIcon style={{ height: "1.5em", float: "left" }} />
          <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Settings</div>
          <ChevronDownIcon
            style={{
              height: "1.5em",
              float: "left",
              transform: expand ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease-in-out",
            }}
          />
        </div>
        <div className="btn btn-default pull-right" style={{ marginRight: 10 }}>
          <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Connected</div>
        </div>
      </div>
      <div className="col-xs-12">
        {expand ?
          <form onSubmit={handleSubmit(saveViftoData)}>
            <div className="row" style={{ padding: 0, paddingRight: '1.5rem' }}>
              <button
                className="btn btn-primary pull-right"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  disconnect()
                }}
              >
                <MinusIcon style={{ height: "1.5em", float: "left" }} />
                <div style={{ float: "left", marginLeft: 5 }}>Disconnect</div>
              </button>
            </div>
            <div className="row" style={{ paddingBottom: 0, paddingTop: 0 }}>
              <h5>Organisation</h5>

              <div className="col-xs-12 pl-0 pr-0" style={{ marginTop: 10 }}>
                <div className="col-xs-6">
                  <Select
                    value={_.find(tenants, { value: tenant })}
                    onChange={(selectedOption) => {
                      setTenant(selectedOption.value);
                      setUpdateTenant(true);
                    }}
                    isDisabled={disabled}
                    options={tenants}
                  />
                </div>

                <div className="col-xs-6">
                  {updateTenant &&
                    <button
                      className="btn btn-success pull-right"
                      style={{ marginTop: 3 }}
                      onClick={(e) => {

                        e.preventDefault()

                        if (saving) return


                        updateViftoTenant(tenant);
                        setUpdateTenant(false);
                      }}
                    >
                      {saving ? "Updating Vifto Organisation..." : "Update Vifto Organisation"}
                    </button>
                  }
                </div>

              </div>
            </div>

            {tenant && hasSelectedTenant && expenseOptions &&
              <>
                <div className="row">
                  <h5>Basic Salaries</h5>

                  <div className="col-xs-6" style={{ marginTop: "15px" }}>
                    <label>Credit</label>

                    <Controller
                      as={Select}
                      control={control}
                      isDisabled={disabled}
                      name={`basic[credit]`}
                      defaultValue={expenseOptions?.find(e => e.value == expenseSettings?.basic?.credit?.value)}
                      options={expenseOptions}
                    />
                    <div className="clearfix" />
                  </div>

                  <div className="col-xs-6" style={{ marginTop: "15px" }}>
                    <label>Debit</label>

                    <Controller
                      as={Select}
                      control={control}
                      isDisabled={disabled}
                      name={`basic[debit]`}
                      defaultValue={expenseOptions?.find(e => e.value == expenseSettings?.basic?.debit?.value)}
                      options={expenseOptions}
                    />
                    <div className="clearfix" />
                  </div>
                </div>

                <div className="row">
                  <h5>Allowances & Overtime</h5>

                  {[...companyDetails?.overtimes, ...companyDetails?.allowances]?.map((allowance) => (
                    <>
                      <div className="col-xs-6" style={{ marginTop: "15px" }} key={allowance.id}>
                        <label>{allowance.name} Credit</label>

                        <Controller
                          as={Select}
                          control={control}
                          isDisabled={disabled}
                          name={`${allowance.id}[credit]`}
                          defaultValue={expenseOptions?.find(e => e.value == expenseSettings?.[allowance.id]?.credit?.value)}
                          options={expenseOptions}
                        />
                        <div className="clearfix" />
                      </div>

                      <div className="col-xs-6" style={{ marginTop: "15px" }}>
                        <label>{allowance.name} Debit</label>

                        <Controller
                          as={Select}
                          control={control}
                          isDisabled={disabled}
                          name={`${allowance.id}[debit]`}
                          defaultValue={expenseOptions?.find(e => e.value == expenseSettings?.[allowance.id]?.debit?.value)}
                          options={expenseOptions}
                        />
                        <div className="clearfix" />
                      </div>
                    </>
                  ))}
                </div>

                {companyDetails?.departments?.length &&
                  <div className="row">
                    <h5>Departments</h5>


                    {companyDetails?.departments?.map((department) => (
                      <>
                        <div className="col-xs-6" style={{ marginTop: "15px" }} key={department.id}>
                          <label>{department.name} Credit</label>

                          <Controller
                            as={Select}
                            control={control}
                            isDisabled={disabled}
                            name={`${department.id}[credit]`}
                            defaultValue={expenseOptions?.find(e => e.value == expenseSettings?.[department.id]?.credit?.value)}

                            options={expenseOptions}
                          />
                          <div className="clearfix" />
                        </div>
                        <div className="col-xs-6" style={{ marginTop: "15px" }}>
                          <label>{department.name} Debit</label>

                          <Controller
                            as={Select}
                            control={control}
                            isDisabled={disabled}
                            name={`${department.id}[debit]`}
                            defaultValue={expenseOptions?.find(e => e.value == expenseSettings?.[department.id]?.debit?.value)}
                            options={expenseOptions}
                          />
                          <div className="clearfix" />
                        </div>
                      </>
                    ))}
                  </div>
                }

                <div className="row">
                  <h5>Taxes</h5>

                  {taxNames?.map((taxName) => (
                    <>
                      <div className="col-xs-6" style={{ marginTop: "15px" }} key={taxName}>
                        <label>{taxName} Credit</label>

                        <Controller
                          as={Select}
                          control={control}
                          isDisabled={disabled}
                          name={`${taxName}[credit]`}
                          defaultValue={expenseOptions?.find(e => e.value == expenseSettings?.[taxName]?.credit?.value)}
                          options={expenseOptions}
                        />
                        <div className="clearfix" />
                      </div>
                      <div className="col-xs-6" style={{ marginTop: "15px" }}>
                        <label>{taxName} Debit</label>

                        <Controller
                          as={Select}
                          control={control}
                          isDisabled={disabled}
                          name={`${taxName}[debit]`}
                          defaultValue={expenseOptions?.find(e => e.value == expenseSettings?.[taxName]?.debit?.value)}
                          options={expenseOptions}
                        />
                        <div className="clearfix" />
                      </div>
                    </>
                  ))}
                </div>
                <div className="pull-right">
                  {!disabled && (
                    <button
                      className="btn btn-success"
                      type="submit"
                    >
                      {(saving && "Saving...") || "Save"}
                    </button>
                  )}
                </div>
              </>
            }
          </form>
          : null}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const {
    tenant,
    taxNames,
    saving,
    expenseOptions,
  } = state?.integration?.accounting?.vifto || {};
  const { tenants, expenseSettings } = state?.integration?.accounting?.vifto?.settings || {}

  return {
    disabled: state?.permissions?.my?.permissions?.settings == "Read",
    connected: !!state?.integration?.accounting?.vifto,
    tenants: tenants?.map(o => ({ label: o.name, value: o.id })),
    currentTenant: tenant,
    saving,
    expenseOptions: expenseOptions?.map(e => ({ label: e.fullName, value: e.code, id: e.id, })) || [],
    companyDetails: state?.company?.settings,
    taxNames,
    expenseSettings,
    hasSelectedTenant: !!tenant,
  }
}

const mapDispatchToProps = (dispatch) => ({
  viftoConnect: (username, password) => dispatch(VIFTO_ACTIONS.viftoConnect(username, password)),
  disconnect: () => dispatch(VIFTO_ACTIONS.disconnectVifto()),
  updateViftoTenant: (tenant) => dispatch(VIFTO_ACTIONS.updateViftoTenant(tenant)),
  getViftoExpenseSettings: () => dispatch(VIFTO_ACTIONS.getViftoExpenseSettings()),
  updateViftoDetails: (settings) => dispatch(VIFTO_ACTIONS.updateViftoDetails(settings)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ViftoSettings)